/* eslint-disable react/jsx-no-useless-fragment */
import React, { useCallback, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { withRouter } from "react-router-dom";

function DeleteModel({ onClick, text, className, listItem }: any) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onClickHandler = useCallback(() => {
    setTimeout(() => {
      onClick();
    }, 500);
    handleClose();
  }, [onClick]);

  return (
    <>
      {text ? (
        <span aria-hidden="true" className={`${className || ""} ms-3 cursor-pointer`} onClick={handleShow}>
          {text || "Delete"}
        </span>
      ) : (
        <>
          {listItem ? (
            <i aria-hidden="true" onClick={handleShow} className="fa-regular fa-trash-can cursor-pointer" />
          ) : (
            <button
              aria-hidden="true"
              onClick={handleShow}
              className={`${className || "position-absolute"} btn btn-danger btn-sm btn-icon top-0 end-0 rounded me-2 mt-2 zindex-1`}
              type="button"
            >
              <i className="fa-regular fa-trash-can" />
            </button>
          )}
        </>
      )}

      <Modal
        className="deleteModel"
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        backdropClassName="signupModalWrapBackdrop"
        centered
      >
        <Modal.Body className="shadow-lg">
          <h6>Are you sure you want to {text || "delete"}?</h6>
          <div className="text-end mt-3">
            <Button variant="outline-danger" onClick={handleClose}>
              Close
            </Button>
            <Button className="ml-2" onClick={onClickHandler} variant="success">
              Yes
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default withRouter(DeleteModel);
